import { useTranslation } from 'react-i18next';
import type { CacheTier } from '../types/cacheAdmin';

interface CacheTierBadgeProps {
  tier: CacheTier;
}

/**
 * CacheTierBadge — L1/L2 계층 배지.
 * L1 = 파랑 계열, L2 = 보라 계열 (design-tokens CSS var 만 사용)
 */
export function CacheTierBadge({ tier }: CacheTierBadgeProps) {
  const { t } = useTranslation();
  const isL1 = tier === 'L1';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 'var(--radius-full, 9999px)',
        fontSize: 'var(--font-size-xs)',
        fontWeight: 600,
        letterSpacing: '0.03em',
        background: isL1
          ? 'var(--color-info-subtle, #dbeafe)'
          : 'var(--color-brand-subtle, #ede9fe)',
        color: isL1
          ? 'var(--color-info, #1d4ed8)'
          : 'var(--color-brand-primary, #6200ee)',
        border: `1px solid ${isL1 ? 'var(--color-info-border, #bfdbfe)' : 'var(--color-brand-border, #c4b5fd)'}`,
      }}
      aria-label={`계층: ${tier}`}
    >
      {tier} · {t(`cacheAdmin.card.tier.${tier}`)}
    </span>
  );
}
